import React from 'react';
import { MessageSquareText } from 'lucide-react';
import { FindingStatusReason } from '../../types/finding';

interface FindingStatusReasonNoteProps {
  statusReason: FindingStatusReason;
}

const formatDateTime = (dateString: string) =>
  new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

/** The reason a person gave for the finding's current status, with when they gave it. */
const FindingStatusReasonNote: React.FC<FindingStatusReasonNoteProps> = ({ statusReason }) => (
  <div className="flex items-start gap-2 rounded-lg border border-ui-border-primary bg-ui-background-tertiary px-3 py-2">
    <MessageSquareText className="w-3.5 h-3.5 mt-0.5 text-ui-text-tertiary flex-shrink-0" />
    <div className="min-w-0">
      <div className="text-xs font-medium text-ui-text-tertiary uppercase tracking-wider">
        Reason
        <span className="normal-case tracking-normal font-normal"> · {formatDateTime(statusReason.created_at)}</span>
      </div>
      {/* Plain text, never Markdown: this is user input shown to the whole organization. */}
      <p className="text-sm text-ui-text-secondary whitespace-pre-wrap break-words mt-0.5">{statusReason.reason}</p>
    </div>
  </div>
);

export default FindingStatusReasonNote;
